import { openProfileDocument } from "../../../backend/transport";
import React from 'react';
import { useLocation } from 'react-router-dom';
import { BUTTON, POPUP_TYPE, ROUTES, TITLES } from '../../../constants';
import DetailTable from '../../common/DetailTable';
import { Button } from '../../shared';
import { DetailBox, TitleBar } from '../../common';
import { packageDetailsBox } from '../../../utils/dataCompiler/packageDataCompiler';
import { printLabelPackage } from '../../../service/package';
import { popup } from '../../../utils';
import { useLoader } from '../../../context/LoaderContext';
import { useDebounce } from '../../../hooks';
// import PrintLabelModal from './PrintLabelModal';

export const PackageBlpOverview = () => {
  const { state } = useLocation();
  const { setLoading } = useLoader();
  // const [isModalOpen, setIsModalOpen] = useState(false);
  const columns = ['SKU', 'Batch No.', 'Quantity'];

  // const handlePrintLabelClick = () => {
  //   setIsModalOpen(true);
  // };

  // const handleCloseModal = () => {
  //   setIsModalOpen(false);
  // };

  const handlePrintLabel = useDebounce(() => {
    popup(POPUP_TYPE.SUCCESS, 'Label Printing Initiated');
    const boxType = state?.data?.data?.is_mixed;
    const mixType = boxType ? 'mix' : 'single';
    // Make an API call or perform other actions with the payload
    printLabelPackage({
      // data: payload,
      data: {
        sizes: ['12_4'],
        package_types: [mixType],
        package_ids: Array.isArray(state?.data?.data?.id)
          ? state?.data?.data?.id.map((id) => id.id)
          : [state?.data?.data?.id],
      },
    })
      .then((response) => {
        if (response.data.length > 0) {
          setLoading(false);
          const url = response.data[0].split('?')[0];
          openProfileDocument(url, '_blank', 'noreferrer');
        }
      })
      .catch(() => {
        setLoading(false);
      });
  }, 1000);

  return (
    <>
      <TitleBar
        title={[
          { text: TITLES.PACKAGE, route: ROUTES.PACKAGE },
          { text: state?.data?.BLP, route: ROUTES.NULL },
        ]}
      />
      <div className="scroll-div">
        <div className="d-flex justify-content-end mb-3">
          <Button
            clickHandler={handlePrintLabel}
            className="border-0 blue-btn d-flex align-items-center justify-content-center py-2 px-3">
            {BUTTON.PRINT_LABEL}
          </Button>
        </div>
        <DetailBox colCount={2} colData={state?.data?.data} dataCompiler={packageDetailsBox} />
        <DetailTable
          title={'"' + state?.data?.BLP + '" Overview'}
          columns={columns}
          data={state?.data?.SKU_Details}
        />
      </div>
      {/* {isModalOpen && (
        <PrintLabelModal
          onClose={handleCloseModal}
          onSubmit={handleSubmitModal}
          packageData={state?.data?.data?.id}
        />
      )} */}
    </>
  );
};
